import { apiSlice } from "../api/apiSlice";

export const noticiasApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    createToken: builder.mutation({
      query: (email)=>({
        url: 'create-reset-token',
        method: 'post',
        body: email
      })
    }),
    exchangeToken: builder.mutation({
      query: (changePassword)=>({
        url: 'exchange-reset-token',
        method: 'post',
        body: changePassword
      })
    }),
    changePassword: builder.mutation({
      query: (changePassword)=>({
        url: 'change-password',
        method: 'post',
        body: changePassword
      })
    })
  })
})

export const { useCreateTokenMutation, useExchangeTokenMutation, useChangePasswordMutation} = noticiasApi;